import React, { useState, useMemo, useEffect, useRef, useCallback } from "react";
import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaRegBell } from "react-icons/fa";
import { DropdownTopbarItemToggler } from "../../../../_partials/dropdowns";
import { NODE_API_URL, BASE_URL } from "../../../../../env_config";
import axios from "axios";

export function UserNotificationsDropdown(props) {
  const [notificationdata, setNotificationData] = useState([]);
  const [page, setPage] = useState(1);
  const [toggleButton,setToggleButton] = useState(false)
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const scrollContainerRef = useRef(null);
  const dropdownRef = useRef(null);
  const [notificationCount,setNotificationCount] = useState(0)
  const fetchCount = async() => {
    try {
      const res = await axios({
        method: "POST",
        url: `${NODE_API_URL}/SUPP/fetch-notification-read-status`,
        headers: { 
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem("authToken")}`
        }
      });
      if (res?.data?.newnotifcation) {
        setNotificationCount(res?.data?.count || 0)
      }
      else{
        setNotificationCount(0)
      }
    } catch (error) {
      setNotificationCount(0)
    }
  }
  useEffect(() => {
    fetchCount()
  },[])
  const fetchNotifications = useCallback(async (pageNum, reset = false) => {
    try {
      setLoading(true);
      const res = await axios({
        method: "GET",
        url: `${NODE_API_URL}/SUPP/fetch-notification`,
        params: {
          page: pageNum,
          limit: 10
        },
        headers: { 
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem("authToken")}`
        }
      });

      if (res?.data?.data) {
        setNotificationCount(0)
        setNotificationData(prev => reset ? res.data.data : [...prev, ...res.data.data]);
        setHasMore(res.data.data.length > 0); // Changed to >= for more reliable pagination
      }
    } catch (error) {
      setHasMore(false)
      if (error?.response?.data?.message === "UnAuthorized!") {
        // Handle unauthorized error
      }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if(toggleButton){
      fetchNotifications(1, true);
      setPage(1)
      setNotificationData([])
    }
  }, [toggleButton]);

  const handleScroll = useCallback(() => {
    const container = scrollContainerRef.current;
    if (!container || loading || !hasMore) return;

    const { scrollTop, scrollHeight, clientHeight } = container;
    const isNearBottom = scrollHeight - (scrollTop + clientHeight) < 50; // Increased threshold
    if (isNearBottom) {
      setPage(prev => {
        const newPage = prev + 1;
        fetchNotifications(newPage);
        return newPage;
      });
    }
  }, [loading, hasMore, fetchNotifications]);

  useEffect(() => {
    const timer = setTimeout(() => {
      const container = scrollContainerRef.current;
      if (container) {
        container.addEventListener('scroll', handleScroll);
      }
    }, 300); // wait for dropdown animation/render
  
    return () => {
      clearTimeout(timer);
      const container = scrollContainerRef.current;
      if (container) {
        container.removeEventListener('scroll', handleScroll);
      }
    };
  }, [handleScroll, notificationdata,toggleButton]);
  return (
    <Dropdown drop="down" alignRight ref={dropdownRef}>
      <Dropdown.Toggle as={DropdownTopbarItemToggler} id="kt_quick_notifications_toggle">
        <OverlayTrigger placement="bottom" overlay={<Tooltip id="user-notification-tooltip">Notifications</Tooltip>}>
          <button 
            className="btn btn-icon btn-clean mr-1 pulse pulse-danger" 
            onClick={() => setToggleButton(!toggleButton)}
          >
            <FaRegBell className="text-dark font-size-h3" />
              {/* Red dot with notification count */}
              {notificationCount > 0 && (
                <>
                  <span class="pulse-ring"></span>
                  <span 
                    className="label label-danger position-absolute top-0"
                    style={{right:0}}
                  >
                    <span className="small font-weight-bold">{notificationCount > 99?"99+":notificationCount}</span>
                  </span>
                </>
              )}
          </button>
        </OverlayTrigger>
      </Dropdown.Toggle>
      <Dropdown.Menu 
        className="dropdown-menu p-0 m-0 dropdown-menu-right dropdown-menu-anim-up" 
        style={{ 
          width: "350px"
        }}
      >
        <div className="d-flex flex-column py-3 border-bottom">
          <h4 className="d-flex flex-center">
            <span className="text-dark">Notifications</span>
          </h4>
        </div>

        {/* Scrollable Area */}
        <div 
          ref={scrollContainerRef}
          style={{ 
            maxHeight: "400px", // Use maxHeight instead of fixed height
            overflowY: "auto",
            padding: "0 10px"
          }}
        >
          {notificationdata.length > 0 ? (
            notificationdata.map((value, index) => (
              <div 
                className="dropdown-item" 
                key={`${index+1}`}
                style={{ 
                  borderBottom: "1px solid #eee",
                  minHeight: "60px"
                }}
              >
                <div style={{ width: "100%", padding: "8px 0" }}>
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <strong>{value.title}</strong>
                    <small className="text-muted">{value.created_date}</small>
                  </div>
                  <div className="small text-muted mt-1 text-wrap">{value.body}</div>
                </div>
              </div>
            ))
          ):loading?(
            <div className="dropdown-item text-center py-2">
              <div className="spinner-border spinner-border-sm text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : (
            <div className="dropdown-item text-center py-3">No notifications</div>
          )}


          {!hasMore && notificationdata.length > 0 && (
            <div className="dropdown-item text-center py-2 small text-muted">
              No more notifications
            </div>
          )}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
}